import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "text-align-justify-17", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 17", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { fill: "currentColor", fillRule: "evenodd", transform: "translate(2 4)" },
        React.createElement("rect", { width: 13, height: 1, y: 4, rx: 0.5 }),
        React.createElement("rect", { width: 13, height: 1, rx: 0.5 }),
        React.createElement("rect", { width: 13, height: 1, y: 8, rx: 0.5 })));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
